import { ReactNode, useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import Header from "shared/Header";
import Menu from "shared/Menu";
import { ACCESS_TOKEN } from "utils/constant";

const MainLayout = ({ children }: { children: ReactNode }) => {
  const token = localStorage.getItem(ACCESS_TOKEN);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  // Close menu on Escape key press
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape" && isMenuOpen) {
        closeMenu();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isMenuOpen]);

  return token ? (
    <div className="flex flex-col w-full h-screen md:flex-row">
      <Menu isMenuOpen={isMenuOpen} closeMenu={closeMenu} />
      <div className="flex flex-col w-full h-full md:w-5/6">
        <Header
          isMenuOpen={isMenuOpen}
          toggleMenu={toggleMenu}
          closeMenu={closeMenu}
        />
        <div className="overflow-y-auto h-full max-w-full bg-gray-100 scroll-smooth w-full p-4">
          {children}
        </div>
      </div>
    </div>
  ) : (
    <Navigate to="/" />
  );
};

export default MainLayout;
